// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentLoader_root__2Ov3V","loader":"ContentLoader_loader__2qpxD","disabled":"ContentLoader_disabled__1BXtu"};